'use strict';
import Player from '@vimeo/player';
const SELECTOR = '.js-header-video';
const isReducedMotion = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

export function init() {
    const elements = document.querySelectorAll(SELECTOR);
    if (!elements.length) {
        return;
    }

    elements.forEach(element => {
        // Get the video selector from the data attribute, or use a default
        const videoSelector = element.dataset.headerVideoIframe || '.header__video';

        // First try to find by the selector
        let playerElements = element.querySelectorAll(videoSelector);

        // If not found, look for Vimeo iframes or elements with vimeo attributes
        if (!playerElements.length) {
            // Try to find Vimeo iframes
            playerElements = document.querySelectorAll('iframe[src*="vimeo"], iframe[src*="player.vimeo"], [data-vimeo-id], [data-vimeo-url]');
        }

        if (!playerElements.length) {
            return;
        }

        if (!isReducedMotion) {
            element.setAttribute('data-vimeo-autoplay', 'true');
        } else {
            console.log('Reduced motion is enabled, not setting autoplay');
        }

        const overlayElement = element.querySelector('.header__video-overlay');

        // Find all .home-hero__pause buttons on the page
        const playPauseElements = document.querySelectorAll('.home-hero__pause');

        // Function to update SVG icons
        const updatePauseIcons = isPlaying => {
            const iconHTML = isPlaying
                ? '<svg class="o-icon o-icon--pause"><use xlink:href="#pause"></use></svg>'
                : '<svg class="o-icon o-icon--play"><use xlink:href="#play"></use></svg>';

            // Update icons in .btn--pause buttons
            const btnPauseElements = document.querySelectorAll('.btn--pause');
            btnPauseElements.forEach(button => {
                const iconContainer = button.querySelector('.btn--pause div');
                if (iconContainer) {
                    iconContainer.innerHTML = iconHTML;
                }
            });

            // Also update icons in .home-hero__pause buttons if they have icon containers
            playPauseElements.forEach(button => {
                const iconContainer = button.querySelector('div, .icon-container, .btn-icon');
                if (iconContainer) {
                    iconContainer.innerHTML = iconHTML;
                }
            });
        };

        const updateButtons = playing => {
            // Update all play/pause buttons
            playPauseElements.forEach(playPauseElement => {
                if (playing) {
                    playPauseElement.classList.remove('paused');
                    // Update text if there's a text element inside
                    const textElement = playPauseElement.querySelector('.header__video-btn-text');
                    if (textElement) {
                        textElement.textContent = 'Pause';
                    }
                } else {
                    playPauseElement.classList.add('paused');
                    // Update text if there's a text element inside
                    const textElement = playPauseElement.querySelector('.header__video-btn-text');
                    if (textElement) {
                        textElement.textContent = 'Play';
                    }
                }
            });

            // Update SVG icons
            updatePauseIcons(playing);
        };

        playerElements.forEach((playerElement, index) => {
            try {
                playerElement.player = new Player(playerElement);

                playerElement.player.on('play', () => {
                    updateButtons(true);
                });

                playerElement.player.on('pause', () => {
                    updateButtons(false);
                });

                playerElement.player.on('loaded', () => {
                    // Use the toggle class from data attribute if available
                    const toggleClass = element.dataset.headerVideoToggleClass || 'header__video--loaded';
                    setTimeout(() => {
                        element.classList.add(toggleClass);
                    }, 500);

                    if (isReducedMotion) {
                        playerElement.player.pause();
                        updateButtons(false);
                    } else {
                        // Set initial state to playing if autoplay is enabled
                        updateButtons(true);
                    }
                });
            } catch (error) {
                console.error(`Error initializing player ${index + 1}:`, error);
            }
        });

        const playPause = () => {
            playerElements.forEach(playerElement => {
                playerElement.player.getPaused().then(paused => {
                    if (paused) {
                        playerElement.player.play();
                    } else {
                        playerElement.player.pause();
                    }
                    updateButtons(!paused);
                }).catch(error => {
                    console.error('Error getting paused state:', error);
                });
            });
        };

        if (overlayElement) {
            overlayElement.addEventListener('click', playPause);
        }

        // Add click listeners to all .home-hero__pause buttons
        playPauseElements.forEach(playPauseElement => {
            playPauseElement.addEventListener('click', playPause);
        });

        // Also add click listeners to .btn--pause buttons if they exist
        const btnPauseElements = document.querySelectorAll('.btn--pause');
        btnPauseElements.forEach(button => {
            button.addEventListener('click', playPause);
        });
    });
}
